<template>

  <div class="main">
    <header>
    <div class="text" style="float: left;">
       <!-- <h2 >Welcome！</h2> -->
        <p>太原市互联网租赁自行车考核平台[企业端]</p>	
    </div>
  <div class="data">
    <el-date-picker
      v-model="ayears"
      type="year"
      format="yyyy"
      value-format="yyyy"
      @change="pickerChangeFn"
      placeholder="请选择年份">
    </el-date-picker>
  </div>
      <div style="  clear:both;"></div>
    </header>
      <!-- <el-row :gutter="24">
        <el-col :span="6" v-for="item in scores" :key="item.id">
          <div class="grid-cont bg-purple">
            <img  v-if="item.grade=='A'" src="../assets/images/a2.png" />

            <img  v-else-if="item.grade=='B'" src="../assets/images/b2.png" />

            <img   v-else-if="item.grade=='C'" src="../assets/images/c2.png" />

            <img   v-else src="../assets/images/d2.png" />

            <div class="text"> <h3 v-if="item.totalPoints>0">{{item.totalPoints}}</h3><h3 v-else style="font-weight: normal">暂未评分</h3>
              <p v-if="item.quarter ==1">第一季度考核评分</p>
              <p v-else-if="item.quarter ==2">第二季度考核评分</p>
              <p v-else-if="item.quarter ==3">第三季度考核评分</p>
              <p v-else-if="item.quarter ==4">第四季度考核评分</p>
            </div>
          </div>

        </el-col>
      </el-row> -->
    <el-row :gutter="24">
      <el-col :span="16" >
        <div class="grid-conts bg-purple">
         <h1>满意度调查</h1>
        <div id = 'mains' style="width: 100%; height: 261px"></div>
        </div>
      </el-col>
      <el-col :span="8" >
        <div class="grid-conts bg-purple">
          <h1>车辆总数</h1>
          <div id = 'conta' style="width: 100%; height: 261px"></div>
          <p style="font-size: 0.20rem;color:#5B5B5B;margin-top: -40px">车辆总数:{{ cartotal }}辆</p>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="16" >
        <div class="grid-conts bg-purple">
          <h1>季度评分细则</h1>
          <el-select v-model="aquarter" class="aquarters"  placeholder="请选择季度" :clearable ="true" >

            <el-option
              v-for="item in quarters"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <div class="table-box">
            <el-table
              :data="list"

              border
              style="width: 100%;"
              height="200">
              <el-table-column
                width="100"
                type="index"
                label="序号"
              >
              </el-table-column>
              <el-table-column

                prop="scoreTypeName"
                label="指标类别"
              >
              </el-table-column>
              <el-table-column

                prop="scoreItemName"
                label="指标项"
              >
              </el-table-column>

              <el-table-column

                prop="scoreValue"
                label="分值"
              >
              </el-table-column>
              <el-table-column


                label="得分"
              >
                <template slot-scope="scope">
                    <div v-if="scope.row.itemScore == null">未评分</div>
                  <div v-else>{{scope.row.itemScore}}</div>
                </template>
              </el-table-column>
            </el-table>

          </div>
        </div>
      </el-col>
      <el-col :span="8" >
        <div class="grid-conts bg-purple">
          <h1>资料上传</h1>
          <el-select v-model="bquarter" class="aquarters" :popper-append-to-body="false" placeholder="请选择季度" :clearable ="true">

            <el-option
              v-for="item in quarters"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <div class="table-box">
            <el-table
              :data="Filelist"
              border
              style="width: 100%;"
              height="200">
              <el-table-column
                width="100"
                prop="scoreItemName"
                label="指标项"
              >
              </el-table-column>
              <el-table-column
                label="考核资料"
              >
                <template slot-scope="scope">
                  <div v-for="items in scope.row.fileJson" :key="items.id">
                    <el-link  type="primary" :href="items.fileUrl" target="_blank">{{items.fileName}}</el-link>
                    <br/>
                  </div>
                </template>
              </el-table-column>

            </el-table>

          </div>

          </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Index",
  data(){
    return{
      quarters: [
        {   id:1,
          name: '第一季度',

        },
        {   id:2,
          name: '第二季度',

        },
        {
          id:3,
          name: '第三季度',
        },
        {
          id:4,
          name: '第四季度',
        },
      ],
      list:[],
      Filelist:[],
      scores:[
      ],
      cartotal:'',
      operatorpage:1,
      operatortotal:0,
      operator:[],
      pageSize:10,
      ayears:'',
      aquarter:'',
      bquarter:'',
      yess:[],
      noss:[]


    }
  },
  props:["curId"],
  watch:{

    curId:function(value){
      this.selectAllQuarterGrade();
      this.selectVehicleNumByOperatorNum();
      this.selectGradeDetailByArg();
      this.selectScoreFileByQuarter();
      this.selectSatisfactionList();
    },
    aquarter:function(value){
      this.selectGradeDetailByArg();
    },
    bquarter:function(value){
      this.selectScoreFileByQuarter();
    },
    ayears:function (value) {
      this.selectGradeDetailByArg();
      this.selectScoreFileByQuarter();
      this.selectAllQuarterGrade();
    }
  },
  beforeRouteEnter(to,from,next){
    next((vm)=>{
    });
  },

  mounted () {
    this.satisfied();
    window.setTimeout(() => {
      this.selectAllQuarterGrade();
      this.selectVehicleNumByOperatorNum();
      this.selectGradeDetailByArg();
      this.selectScoreFileByQuarter();
      this.selectSatisfactionList();
      this.getVerificationCode();
    }, 200);


  },

  methods:{

    pickerChangeFn(value){ // 日期选择器改变事件 ~ 解决日期选择器清空 值不清空的问题
      if(value===null){
        this.ayears = value
      }},
    selectScoreFileByQuarter(){
      let that = this;
      let myDate = new Date();
      let years = myDate.getFullYear(); //获取当前年
      this.ayears=this.ayears||''+years;
      let mon = myDate.getMonth() + 1; //获取当前月
      let aquarters = 1
      if(mon>=1&&mon<4){
        aquarters = 1;
      }else if(mon>=4&&mon<7){
        aquarters = 2;
      }else if(mon>=7&&mon<10){
        aquarters = 3;
      }else if(mon>=10&&mon<12){
        aquarters = 4;
      }
      this.bquarter= this.bquarter || aquarters;
      let ScoreFileByQuarterdata = {
        operatorNum:this.curId,
        year: this.ayears,
        quarter:this.bquarter
      }
      this.$axios
        .post('/webapi/scoreItemFile/selectScoreFileByQuarter',ScoreFileByQuarterdata)
        .then(function (res) {
          //console.log(res)
          if(res.data.code==200){
            that.Filelist = res.data.data;

          }else {
            that.$message.error(res.data.msg)
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },


    selectGradeDetailByArg(){
      let that = this;
      let myDate = new Date();
      let years = myDate.getFullYear(); //获取当前年
      this.ayears=this.ayears||''+years;
      let mon = myDate.getMonth() + 1; //获取当前月
      let aquarters = 1
      if(mon>=1&&mon<4){
        aquarters = 1;
      }else if(mon>=4&&mon<7){
        aquarters = 2;
      }else if(mon>=7&&mon<10){
        aquarters = 3;
      }else if(mon>=10&&mon<12){
        aquarters = 4;
      }
      this.aquarter= this.aquarter || aquarters;
      let DetailByArgdata = {
        operatorNum:this.curId,
        year: this.ayears,
        quarter:this.aquarter
      }
      this.$axios
        .post('/webapi/greadeDetail/selectGradeDetailByArg',DetailByArgdata)
        .then(function (res) {
          //console.log(res)
          if(res.data.code==200){
            that.list = res.data.data;

          }else {
            that.$message.error(res.data.msg)
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },

    selectAllQuarterGrade(){

      let that = this;
      let myDate = new Date();
      let years = myDate.getFullYear(); //获取当前年
      this.ayears=this.ayears||''+years;
        let AllQuarterGradedtata={
          operatorNum:this.curId,
          year:this.ayears
        }
      this.$axios
        .post('/webapi/grade/selectAllQuarterGrade',AllQuarterGradedtata)
        .then(function (res) {

          if(res.data.code==200){
           that.scores = res.data.data;
          }else {
            that.$message.error(res.data.msg)
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },
    selectVehicleNumByOperatorNum(){
      let that = this;

      let OperatorNumtata={
        operatorNum:this.curId,
      }
      this.$axios
        .post('/webapi/vehicle/selectVehicleNumByOperatorNum',OperatorNumtata)
        .then(function (res) {

          if(res.data.code==200){
            that.cartotal = res.data.data;
            that.settale();
          }else {
            that.$message.error(res.data.msg)
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },


    selectSatisfactionList(){
      let that = this;

      let Satisfactiondata={
        operatorNum:this.curId,
      }
      this.$axios
        .post('/webapi/satisfaction/selectSatisfactionList',Satisfactiondata)
        .then(function (res) {

          if(res.data.code==200){
           for (let i =0 ; i<res.data.data.length;i++){
                let yes = res.data.data[i].satisfactionNum;
                 let nos = res.data.data[i].discontentNum;
             that.yess.push(yes);
             that.noss.push(nos);
             console.log()
           }
            that.satisfied();
          }else {
            that.$message.error(res.data.msg)
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },

    satisfied(){

      let chartDom = document.getElementById('mains');
      let myChart = this.$echarts.init(chartDom);
      window.addEventListener('resize', function () {
        myChart.resize();

      });
      let option;

      option = {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: ['第一季度', '第二季度', '第三季度', '第四季度']
          }
        ],
        yAxis: [
          {

            type: 'value',
            min: 0,
            max: 100,
            position: 'left',

            boundaryGap: [0, 0.01],
            axisLabel: {
              show: true,
              color: '#86909C',
              interval: 'auto',
              formatter: '{value}%'
            }
          }
        ],
        series: [
          {
            name: '满意',
            type: 'line',

            itemStyle : {
              normal : {
                color:'#6DD98A',
                lineStyle:{
                  color:'#6DD98A'
                }
              }
            },
            areaStyle: {
              color: "#6DD98A" // 0% 处的颜色
            },
            emphasis: {
              focus: 'series'
            },
            data:this.yess
          },
          {
            name: '不满意',
            type: 'line',

            itemStyle : {
              normal : {
                color:'#F58180',
                lineStyle:{
                  color:'#F58180'
                }
              }
            },
            areaStyle: {
              color: "#F58180" // 0% 处的颜色
            },
            emphasis: {
              focus: 'series'
            },
            data:this.noss
          },


        ]
      };
      myChart.setOption(option);

    },

    settale(){

            let dom = document.getElementById("conta");
            let myChart = this.$echarts.init(dom);
            window.addEventListener('resize', function () {
              myChart.resize();

            });
             let option;
            option = {
              color:['#FFD103','#ffffff'],
              tooltip: {
                trigger: 'item'
              },
              legend: {
                show: false,
              },

              series: [
                {
                  name: '单车数量统计',
                  type: 'pie',
                  radius: ['30%', '60%'],
                  avoidLabelOverlap: false,
                  label: {
                    normal: {
                      show: true,
                      position: 'center',
                      color:'#4c4a4a',
                      formatter: this.cartotal,
                      rich: {
                        total:{
                          fontSize: 40,
                          fontFamily : "微软雅黑",
                          color:'#222222'
                        },
                        active: {
                          fontFamily : "微软雅黑",
                          fontSize: 16,
                          color:'#444444',
                          lineHeight:30,
                        },
                      }
                    },
                    emphasis: {//中间文字显示
                      show: true,
                    }
                  },
                  labelLine: {
                    show: false
                  },

                  data: [this.cartotal,0]
                }
              ]
            };


              myChart.setOption(option);





    },


  },


}
</script>
<style>

</style>
<style scoped>

@import '../assets/css/style.css';
/deep/ .el-input--suffix .el-input__inner{
  border: 0;
  font-family: PingFang SC-粗体, PingFang SC;
  font-weight: normal;
  color: #676767;
}
.main {padding: 25px;background:#cca8a8}
.text h2{
  font-size: 0.4rem;
  font-weight: bold;
  color: #222222;
  text-align: left;
  margin:8px 0 ;
}
    .text p{
      font-size: 0.20rem;
      font-family: PingFang SC-中等, PingFang SC;
      font-weight: normal;
      color: #767676;
      line-height:20px;
    }
    .data{
      float: right;

    }
    .data .el-date-editor.el-input{
      width: 134px;
    }
    .grid-cont{
      box-shadow: 0px 3px 13px 0px rgba(204.00000303983688,204.00000303983688,204.00000303983688,0.30000001192092896);
      border-radius: 20px;
      display: flex;
      padding: 30px;
      flex-direction: row;/*这里可以不写，flex布局默认方向横向即row*/
      justify-content: center;
      align-items: center;
    }
.grid-cont img{
  width: 1rem;
  height: auto;
  margin-right: 0.22rem;
  margin-left: 0.1rem;
}
.grid-cont .text h3{
  font-size: 0.28rem;
  text-align: left;
  margin:  22px 10px;
  line-height: 0;

}
.grid-cont .text p{
  text-align: left;
  margin:  8px 10px;
  font-size: 14px;
}

.grid-conts{

  box-shadow: 0px 3px 13px 0px rgba(204.00000303983688,204.00000303983688,204.00000303983688,0.30000001192092896);
  border-radius: 20px;

  padding: 30px;
  height: 245px;
}
.grid-conts h1{
  font-size: 0.25rem;
  color: #222222;
  margin: 0;
  line-height: 40px;
  float: left;
}
.grid-conts .el-select{
  float: right;
  width: 120px;

}
.table-box{
  margin-top: 52px;
}

</style>



// WEBPACK FOOTER //
// src/view/Index.vue